import {Card, Carousel, Typography} from "antd";
import {Pending} from "@/components/Pending.tsx";
import type {Raid} from "@/raids/rest/RaidSchema.ts";
import {useNavigate} from "@tanstack/react-router";
import {RaidInfoCard} from "@/home/RaidInfoCard.tsx";

type Props = {
  isLoading: boolean,
  top5Raids?: Raid[],
}

export function RaidTop5({isLoading, top5Raids = []}: Props) {

  const navigate = useNavigate();

  function openRaid(id: number): void {
    void navigate({
      to: "/raids/$raidId",
      params: { raidId: String(id) },
    });
  }

  return (
      <div className={"w-full"}>
        <Card title={<Typography.Title level={4}>Beste Ergebnisse</Typography.Title>}>
          <div className={"w-full flex-col justify-center"}>
            {isLoading ? (
                <Pending/>
            ) : (
                <>
                  {top5Raids.length === 0 ? (
                      <Card className={"shadow-[var(--custom-box-shadow)]"}>
                        Keine Daten
                      </Card>
                  ) : (

                      <Carousel autoplay={{dotDuration: true}} autoplaySpeed={5000}>
                        {
                          top5Raids.map(raid => {
                            return <div className={"p-4"} key={raid.id}>
                              <div className={"flex justify-center"}>
                                <RaidInfoCard raid={raid} openRaid={openRaid} />
                              </div>
                            </div>
                          })
                        }
                      </Carousel>
                  )}
                </>
            )}
          </div>
        </Card>
      </div>
  );
}